import React, { Component } from "react";
/*
props {
	fileType: 'image/*',
	onChange: 
}
*/

class FileSelector extends Component {
  state = {
    allowMultipleImages: false
  };

  onFileUploadCB = null;

  imgKey = "";

  triggerClick = (allowMultipleImages, imgKey) => {
    this.imgKey = imgKey;
    if (!!allowMultipleImages !== this.state.allowMultipleImages) {
      this.setState(
        {
          allowMultipleImages
        },
        () => {
          this.inputElem && this.inputElem.click();
        }
      );
    } else {
      this.inputElem && this.inputElem.click();
    }
  };
  render() {
    let addInputFileProps = {};
    if (this.state.allowMultipleImages && !this.props.forVideo) {
      addInputFileProps = {
        multiple: "multiple"
      };
    }
    const acceptFileType =
      this.props.accept || (this.props.forVideo ? "video/*" : "image/*");
    return (
      <div className="file-selector-div" style={{ display: "none" }}>
        <input
          id="upload"
          type="file"
          accept={acceptFileType}
          onChange={(e) => {
            this.props.onChange &&
              this.props.onChange(e, {
                imgKey: this.imgKey,
                inputElem: this.inputElem,
                onFileUploadCB: this.onFileUploadCB
              });
          }}
          onClick={(e) => {
            e.stopPropagation();
            e.target.value = null;
            this.props.onClick && this.props.onClick(e);
          }}
          ref={(ref) => (this.inputElem = ref)}
          {...addInputFileProps}
        />
      </div>
    );
  }
}

export default FileSelector;
